import { render, staticRenderFns } from "./onebox-resultpayment.vue?vue&type=template&id=9e83645a&"
import script from "./onebox-resultpayment.vue?vue&type=script&lang=js&"
export * from "./onebox-resultpayment.vue?vue&type=script&lang=js&"
import style0 from "./onebox-resultpayment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports